import React, {useEffect} from 'react'
import Home from "./Home.jsx"

const HomeContainer = () => {

    useEffect(() => {
    }, [])

    return (
        <Home/>
    )
}

export default HomeContainer